import React from 'react';
import { Stack } from '@moda/om';
import { useFeatureFlag } from '@moda/portal-stanchions';
import { DIVIDER_LAYOUT_TYPES } from '../DividerPumoModule';
import { RecommendationsModule, ALGORITHMS } from '../RecommendationsPumoModule';
import { LazyLoad } from '../LazyLoad';
import { RecommendationsVariantFragment } from '../../generated/types';
import { useAlgoliaRecommendations } from '../../hooks/useAlgoliaRecommendations';
import { LookRecommendations } from './LookRecommendations';

interface Props {
  variant: RecommendationsVariantFragment;
}

export const ProductRecommendations: React.FC<Props> = ({ variant }) => {
  const algoliaRecommendations = useAlgoliaRecommendations();
  const category = variant.category[0]?.replace(/[_\s]/g, '-').toLowerCase();
  const useNewDividerLine = useFeatureFlag('new-divider-line', [
    { default: false },
    { if: true, then: true }
  ]);

  const divider = useNewDividerLine
    ? DIVIDER_LAYOUT_TYPES.LINE_ABOVE
    : DIVIDER_LAYOUT_TYPES.ONE_LINE;

  return (
    <Stack space={6}>
      <LazyLoad>
        <LookRecommendations />

        {!algoliaRecommendations['looking-similar'] && (
          <RecommendationsModule
            algorithm={ALGORITHMS.SIMILAR_PRODUCTS}
            variant={variant}
            identifier={variant.id}
            divider={{
              layoutType: divider,
              text: 'You May Also Like'
            }}
          />
        )}

        {algoliaRecommendations['looking-similar'] && (
          <RecommendationsModule
            algorithm={ALGORITHMS.LOOKING_SIMILAR}
            identifier={variant.id}
            divider={{
              layoutType: divider,
              text: 'You May Also Like'
            }}
          />
        )}

        {category === 'fine-jewelry' && (
          <RecommendationsModule
            algorithm={ALGORITHMS.FROM_THIS_DESIGNER}
            variant={variant}
            identifier={variant.id}
            divider={{
              layoutType: divider,
              text: 'From This Designer'
            }}
          />
        )}

        <RecommendationsModule
          algorithm={ALGORITHMS.RECENTLY_VIEWED}
          variant={variant}
          identifier={variant.id}
          divider={{
            layoutType: divider,
            text: 'Recently Viewed'
          }}
        />
      </LazyLoad>
    </Stack>
  );
};
